import React, { useEffect, useState } from "react";
import Intermediat_Check_Form from "./intermediat_Check_Form/Intermediat_Check_Form";
import Intermediat_Check_table from "./intermediat_Check_table/Intermediat_Check_table";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAll,
  GetAllIntermediate,
} from "../../../../../../../features/admin/quality_management/resource_requirement/equipment/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";

function Intermediat_Check({ all_instruments }) {
  const [showTable, setShowTable] = useState(false);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchName, setSearchName] = useState({
    unique_id: "",
    instrument_name: "",
    calibration_status_id: "",
    calibrated_id: "",
  });

  const data = useSelector((state) => state.equipment.data);
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAllIntermediate({
        instrument_id: searchName.instrument_id || "",
        instrument_unique_id: searchName.instrument_unique_id || "",
        calibrate_instrument: searchName.calibrate_instrument || "",
        page: page,
        // per_page: data?.data.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);

  const permissions = useSelector((state) => state.auth.permissions);
                    
  const haveReadPermission = permissions?.includes(FixIDS.intermediate_check.List);
  const haveAddPermission = permissions?.includes(FixIDS.intermediate_check.Add);

  return (
    <>
      <div className="imperiality_Form_div">
        { haveAddPermission && <Intermediat_Check_Form
          onProceed={() => setShowTable(true)}
          all_instruments={all_instruments}
          setSearchName={setSearchName}
        /> }
      </div>

      {/* {showTable && ( */}
      <div className="imperiality_table_div">
        { haveReadPermission && <Intermediat_Check_table
        fetchCustomers={fetchCustomers}
          data={data}
          currentPage={currentPage}
          all_instruments={all_instruments}
          setCurrentPage={setCurrentPage}
        /> }
      </div>
      {/* )} */}
    </>
  );
}

export default Intermediat_Check;
